
/* injects from baggage-loader */
require('./style.scss');

import React, { Component } from "react";
import { t } from "../../../helpers/translator";

class GameNotFound extends Component {
    render () {
        return (<div className="game-is-not-found">{t("There are no available games")}</div>);
    }
}

export default GameNotFound;